import { Categorie } from '../../Prima_Nota/Models/Categorie';
import { PartiStoreService } from '../../Progetti/_services/parti-store.service';
import { environment } from 'src/environments/environment';
import { ApiPathsService } from '../../api-paths.service';
import { FileStoreService } from '../../shared/_services/file-store.service';
import { Delete } from 'angular-feather/icons';
import { Prodotto } from '../../Progetti/Models/Prodotto';
import { ProdottiStoreService } from '../../Progetti/_services/prodotti-store.service';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { Observable, Subscription } from 'rxjs';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ServerPaginationService } from 'src/app/shared/_services/server-pagination.service';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { RicercaPaginazione } from 'src/app/Admin/models/sendpersonale';
import { ApiRestService } from '../../Progetti/_services/api-rest.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-lista-prodotti',
  templateUrl: './lista-categorie-parti.component.html',
  styleUrls: ['./lista-categorie-parti.component.scss']
})
export class ListaCategoriePartiComponent implements OnInit {
  categoriedropdownSettings: IDropdownSettings = {
    singleSelection: true,
    closeDropDownOnSelection: true,
    textField: 'categoria',
    searchPlaceholderText: "inserire almeno 3 caratteri",
    allowSearchFilter: true,
    allowRemoteDataSearch: true,
  };
  subscriptions: Subscription = new Subscription();
  Categorie: Categorie[];
  CategorieLineare: Categorie[] = [];
  CategorieSelezionate: Categorie[] = [];
  CategoriaDaModificare: Categorie = null;
  LabelCategoria: string = "";
  titolo = "Categorie ";
  constructor(private route: ActivatedRoute,
    public router: Router,
    private progettistore: PartiStoreService,
    private paginationService: ServerPaginationService,
    private formBuilder: FormBuilder,
    private filestore: FileStoreService,
    public apiPaths: ApiPathsService,
    private apirest: ApiRestService,
    private modalService: NgbModal
  ) {

  }
  ngOnInit() {
    this.progettistore.getCategorieProdotti();
    this.progettistore.$categorieProdotti.subscribe(data => this.Categorie = data);
    this.progettistore.$categorieProdottiLineare.subscribe(data => {
      if (data !== null)
        this.CategorieLineare = data;
    });
  }
  Elimina(value: Categorie) {
    if (confirm("Sei sicuro di voler eliminare questa categoria?")) {
      this.apirest.deleteCategoriaVariazione(value).subscribe(data => {
        this.progettistore.getCategorieProdotti();
      })
    }
  }
  filtroCategoria(item: string) {
    if (item.length >= 3) {
      this.progettistore.getCategorieListanofigli(new RicercaPaginazione(item, undefined, undefined));
    }
  }
  openModal(targetModal: NgbModal, selected: Categorie, selectedParent: Categorie) {
    this.modalService.open(targetModal, {
      centered: true,
      backdrop: 'static'
    });
    this.CategoriaDaModificare = selected;
    this.CategorieSelezionate = [];
    if (selected !== null && selectedParent !== null) {
      this.LabelCategoria = selected.categoria;
      this.CategorieSelezionate.push(selectedParent);
    } else if (selected !== null) {
      this.LabelCategoria = selected.categoria;
      this.CategorieSelezionate = [];
    } else {
      this.LabelCategoria = "";
      this.CategorieSelezionate = [];
    }
  }
  saveModalButton() {
    if (this.CategoriaDaModificare !== null) {
      const updateData = new Categorie();
      updateData.id = this.CategoriaDaModificare.id;
      updateData.categoria = this.LabelCategoria;
      if (this.CategorieSelezionate != null && this.CategorieSelezionate.length > 0)
        updateData.cat_id = this.CategorieSelezionate[0].id;
      else
        updateData.cat_id = undefined;
      this.apirest.updateCategoriaVariazione(updateData).subscribe(data => {
        this.progettistore.getCategorieProdotti();
        this.closeBtnClick()
      });
    } else {
      const updateData = new Categorie();
      updateData.categoria = this.LabelCategoria;
      if (this.CategorieSelezionate != null && this.CategorieSelezionate.length > 0)
        updateData.cat_id = this.CategorieSelezionate[0].id;
      else
        updateData.cat_id = undefined;
      this.apirest.addCategoriaVariazione(updateData).subscribe(data => {
        this.progettistore.getCategorieProdotti();
        this.closeBtnClick()
      });
    }
  }
  deleteModalButton() {
    const updateData = new Categorie();
    updateData.id = this.CategoriaDaModificare.id;
    if (this.CategorieSelezionate != null && this.CategorieSelezionate.length > 0)
      updateData.cat_id = this.CategorieSelezionate[0].id;
    else
      updateData.cat_id = undefined;
    this.apirest.deleteCategoriaVariazione(updateData).subscribe(data => {
      this.progettistore.getCategorieProdotti();
      this.closeBtnClick()
    });
  }
  Delete(cat: Categorie) {
    this.Elimina(cat);
  }

  closeBtnClick() {
    this.modalService.dismissAll();
    //this.ngOnInit();
  }
}
